import styled from 'styled-components';
import colours from 'theme/atoms/colours';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: white;
  display: flex;
  flex-direction: column;
  padding: 30px;
  border-radius: 8px;
  box-sizing: border-box;
  width: 80%;
  max-width: 800px;
  max-height: 80vh;
  overflow: hidden;
  position: relative;
`;

export const CloseButtonSection = styled.div`
  position: sticky;
  top: 0;
  right: 0;
  background: none;
  border: none;
  padding: 5px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const PrintButtonSection = styled.div`
  align-items: center;
  border-top: 1px solid ${colours.neutral[100]};
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  padding: 15px 0 0 0;
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: calc(80vh - 130px);
  overflow-y: auto;
  padding: 0 30px 30px 30px;
`;

export const UserMessage = styled.div`
  margin-bottom: 30px;
`;

export const NurauMessage = styled.div`
  margin-bottom: 30px;
`;

export const Timestamp = styled.div`
  font-size: 0.8em;
  color: #666;
  margin-bottom: 5px;
`;

export const ConversationItemsList = styled.div`
  margin: 10px 0;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 8px;
`;

export const ConversationItem = styled.div`
  margin-bottom: 10px;
  padding: 8px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const ConversationItemTitle = styled.div`
  font-weight: bold;
  margin-bottom: 4px;
`;

export const ConversationItemDescription = styled.div`
  font-size: 0.9em;
  color: #666;
`;
